<compartido-formulario
  *ngIf="formula"
  [configuracion]="configFormulario"
></compartido-formulario>

<div class="cargando" *ngIf="cargando()">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<div class="sin-datos" *ngIf="!cargando() && formula === undefined">
  <mat-icon>info</mat-icon>
  <span>No se encontraron datos de la fórmula.</span>
</div>
